import React from "react";
import { templateOptions } from "../../data/templateData";
import TemplateSelector from "../TemplateSelector";

const ResumeHomePage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background mt-16 ">
      {/* Hero Section */}
      <section className=" text-primary ">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Thouht Code Resume Builder
          </h1>
          <p className="text-lg md:text-xl max-w-2xl mx-auto text-primary/90">
            Build a professional, ATS-friendly resume tailored for every career
            stage.
          </p>
        </div>
      </section>

      <section className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
          Why Choose Our Resume Builder?
        </h2>

        <div className="grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          {[
            {
              title: "ATS-Friendly",
              description:
                "Designed to pass through Applicant Tracking Systems easily",
              icon: (
                <>
                  <rect width="18" height="18" x="3" y="3" rx="2" />
                  <path d="M9 14v1" />
                  <path d="m7 10 2 2 4-4" />
                </>
              ),
            },
            {
              title: "Easy Editing",
              description: "Simple yet powerful editing with real-time preview",
              icon: (
                <>
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                  <path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4Z" />
                </>
              ),
            },
            {
              title: "Multiple Templates",
              description: "Templates designed for different career stages",
              icon: (
                <>
                  <path d="M3 15c0 2.8 2.2 5 5 5s5-2.2 5-5-2.2-5-5-5-5 2.2-5 5z" />
                  <path d="M13 15c0-2.8 2.2-5 5-5s5 2.2 5 5-2.2 5-5 5-5-2.2-5-5z" />
                  <path d="M9.7 10.7c1.1-1.2 2.7-1.8 4.3-1.8s3.2.6 4.3 1.8" />
                  <path d="M9.7 19.3c1.1 1.2 2.7 1.8 4.3 1.8s3.2-.6 4.3-1.8" />
                </>
              ),
            },
          ].map(({ title, description, icon }, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl shadow-md p-6 text-center transition hover:shadow-xl hover:-translate-y-1 duration-300"
            >
              <div className="w-20 h-20 flex items-center justify-center rounded-full bg-primary/10 mx-auto mb-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="text-primary"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  {icon}
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">{title}</h3>
              <p className="text-muted-foreground text-sm">{description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Template Selector */}
      <section id="templates" className="bg-gray-10 py-5">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-1">Choose a Template</h2>
          <TemplateSelector templates={templateOptions} />
        </div>
      </section>
    </div>
  );
};

export default ResumeHomePage;
